import React, { useState } from 'react';
import ParallaxHero from '../components/ParallaxHero';
import { Link } from 'react-router-dom';

const faqs = [
  {
    question: "Hoe zit het met de \"verborgen\" kosten?",
    answer: "Frietplus houdt het graag simpel. Bij ons betaal je een vaste, éénmalige startkost, ongeacht het aantal gasten, ongeacht het aantal kilometers dat we moeten rijden, ongeacht het type evenement. Geen kleine lettertjes, gewoon simpel.",
    icon: "fas fa-euro-sign"
  },
  {
    question: "Hoeveel ruimte hebben jullie nodig?",
    answer: "Het voordeel aan de foodtruck is dat deze compact is en op heel wat plaatsen kan gezet worden. Wat wel belangrijk is dat we de locatie zonder al te zotte toeren kunnen bereiken en de ondergrond stabiel is.\n\nKortom, voorzie een plaats van minimaal 6 meter lang en 3 meter breed + plus service area. Twijfel je? Geef ons een seintje, zodat we samen de ideale plek voor jouw feest kunnen vinden.",
    icon: "fas fa-ruler-combined"
  },
  {
    question: "Zijn wij in orde met de alle regelgeving?",
    answer: "Zeker. Wij voldoen aan alle Belgische voedselveiligheidsnormen en zijn volledig FAVV gecertificeerd.",
    icon: "fas fa-shield-halved"
  },
  {
    question: "Wat als het regent?",
    answer: "Geen probleem! Het weer mag geen dealbreaker zijn. De foodtruck is voorzien van een luifel zodat wij jouw gasten steeds kunnen bedienen en de gasten zorgeloos kunnen genieten van al het lekkers.",
    icon: "fas fa-cloud-rain"
  },
  {
    question: "Mag het een intiem feest zijn?",
    answer: "Absoluut! Onze foodtruck is voorzien van meerdere frietketels en voldoende werkruimte, waardoor we zowel geschikt zijn voor een intiem feestje als voor grote groepen. Frietplus vraagt niet om een minimaal aantal gasten uit te nodigen, wij passen wel een forfaitair bedrag toe van minimaal 650 euro (inclusief BTW en opstartkost). In ruil daarvoor garanderen wij dat jij zorgeloos kan genieten en een vlotte service.",
    icon: "fas fa-heart"
  },
  {
    question: "Mag het wat specialer zijn?",
    answer: "Absoluut! Van vegan tot glutenvrij, van halal tot lactosevrij - wij bereiden alles apart en labelen duidelijk. Geef dietary wensen door bij boeking en wij zorgen dat elke gast kan genieten.\n\nHeb je een schitterend idee, maar vind je je gading niet in onze voorgestelde formules, neem dan contact met ons op. We bezorgen je zo snel mogelijk een op maat gemaakt voorstel.",
    icon: "fas fa-star"
  },
  {
    question: "Wat moet ik doen?",
    answer: "Frietplus zorgt dat je zorgeloos kan genieten van jouw event. Wij rekenen enkel op jouw voor onderstaande zaken:\n\nElektriciteit (1 apart circuit van elk 230V en 16A (= gewoon stopcontact) en een kraantje voor stromend water.",
    icon: "fas fa-list-check"
  },
  {
    question: "Moet ik borden en bestek voorzien?",
    answer: "Zeker niet! Wij voorzien echt alles wat je nodig hebt. Voor al onze lekkere gerechtjes brengen we wegwerpmateriaal of herbruikbare borden/kommen en bestek mee. Ons servies ziet eruit als écht porselein - maar 't is gewoon een pak lichter en niet breekbaar. Na het feest nemen we alles terug mee naar huis, waar we het servies proper maken. Geen afwas voor jou en zo helpen we de natuur ook meteen een handje!",
    icon: "fas fa-utensils"
  },
  {
    question: "Hoe laat kunnen jullie blijven?",
    answer: "De servicetijd hangt af van de keuze binnen het menu en het aantal gasten maar wij zijn steeds minimaal 3 uur ter plaatse. Hierin zit 1 uur opstart-tijd inbegrepen, zodat wij goed voorbereid al jouw gasten kunnen laten genieten. Loopt het wat uit? Geen probleem, wij blijven gerust een kwartiertje langer zodat wij al jouw gasten optimaal kunnen bedienen.\n\nTer voorbereiding van jouw event maken wij steeds duidelijke afspraken over het gewenste startuur.",
    icon: "fas fa-clock"
  },
  {
    question: "Hoe en wanneer betalen?",
    answer: "Om jouw feest zo zorgeloos mogelijk te laten verlopen, werken we liefst op een gestandaardiseerde manier.\n\nWe bezorgen je vooraf steeds een offerte. Tenzij je tijdens je feest nog bijkomende zaken bestelt, zijn je offerte en je eindfactuur gelijk.\n\nWe vragen een voorschot van 50% van de offerteprijs. Het saldo betaal je gewoon na het feest.",
    icon: "fas fa-credit-card"
  }
];

const FAQItem: React.FC<{ item: typeof faqs[0]; index: number }> = ({ item, index }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`rounded-2xl overflow-hidden transition-all duration-300 ${
        open ? 'shadow-md' : 'shadow-sm hover:shadow-md'
      } bg-white`}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full text-left p-5 md:p-6 flex items-center gap-4 group"
        aria-expanded={open}
      >
        <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300 ${
          open ? 'bg-friet-red text-white' : 'bg-friet-red/10 text-friet-red'
        }`}>
          <i className={`${item.icon} text-sm`}></i>
        </div>
        <span className={`flex-1 font-bold text-base md:text-lg transition-colors duration-200 ${
          open ? 'text-friet-red' : 'text-friet-black group-hover:text-friet-red'
        }`}>
          {item.question}
        </span>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
          open ? 'border-friet-red bg-friet-red text-white rotate-45' : 'border-friet-red/30 text-friet-red/60'
        }`}>
          <i className="fas fa-plus text-xs"></i>
        </div>
      </button>

      <div className={`transition-all duration-300 ease-in-out overflow-hidden ${
        open ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <div className="px-5 md:px-6 pb-6 pl-[72px] space-y-3">
          <div className="w-full h-px bg-friet-red/10 mb-4"></div>
          {item.answer.split('\n\n').map((para, j) => (
            <p key={j} className="text-friet-oak/80 leading-relaxed text-sm md:text-base">{para}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

const FAQPage: React.FC = () => {
  return (
    <div>
      <ParallaxHero
        image="/assets/gallery/500119355_17862875781406413_7107130305137472544_n.jpg"
        title="How it rolls"
        subtitle="- Alles wat je wil weten -"
      />

      <section className="py-16 md:py-24 bg-friet-beige">
        <div className="max-w-2xl mx-auto px-4">
          <div className="space-y-3">
            {faqs.map((item, i) => (
              <FAQItem key={i} item={item} index={i} />
            ))}
          </div>

          <div className="mt-12 text-center bg-white rounded-2xl p-8 shadow-sm">
            <p className="text-friet-oak/70 font-serif mb-4">Staat jouw vraag er niet bij?</p>
            <Link
              to="/private-parties"
              className="inline-flex items-center gap-2 bg-friet-red text-white px-8 py-3 rounded-full font-bold text-sm hover:bg-friet-black transition-all"
            >
              <i className="fas fa-envelope text-xs"></i>
              Stel je vraag
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default FAQPage;
